/** @jsx jsx */
import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import AnimatedNumber from "react-animated-number";
import { fromJS } from "immutable";
// components
import CardListWrapper from "./CardListWrapper";
import SectionHelmet from "./SectionHelmet";
import SortSelectField from "../components/SortSelectField";
// containers
import BannerCarousel from "../containers/GroupBannerCarouselWithSubscription";
import GroupFilterCardList from "../containers/GroupFilterCardListWithSubscription";
import GroupGenreIconStripWithSubscription from "../containers/GroupCategoryStripWithSubscription";
import TimeBasedLinks from "../containers/TimeBasedLinksWithSubscription";
// helpers
import { CLEVERTAP_ACTIONS } from "../helpers/constants";
import { sendClevertapEvent } from "../helpers/misc";
import Loader from "./Loader";
import GroupMonumentsCityFilterCardList from "../containers/GroupMonumentsCityFilterCardList";
import { MonumentsCityDropdown } from "./MonumentsCityDropdown";
import MonumentsAnimatedNumberWithSubscription from "../containers/MonumentsAnimatedNumberWithSubscription";
import { generateSEOGroupCategoryLink, generateSamePageURL } from "../helpers/linkGenerators";
import { jsx, css } from "@emotion/core";
import theme, { colors } from "../styles/common";
import ELPPageBanner from "./ELPPageBanner";
import { mediaFeatures } from "../styles/common";
import HomePageCitySelector from "../containers/HomePageCitySelectorWithSubscription";
import CitySelectorContext from "../contexts/CitySelectorContext";
import cookies from "browser-cookies";
import { connect } from "react-redux";
import { getIsCityChanged } from "../selectors";
const KeywordGoOut = `
	font-weight: 700;
	color: ${colors.paytmBlue};
`;
const FilterHeadWrapper = `
	width: 80vw;
	margin: 0 auto;
	@media screen and ${mediaFeatures["for-mobile"]} {
		width: 100vw;
		padding-left: 6vw;
	}
	@media screen and ${mediaFeatures["for-tablet-only"]} {
		width: 100vw;
		padding-left: 6vw;
	}
`;
const FilterHead = `
	margin-bottom: 2.5vw;
	margin-top: 2.5vw;
	display: flex;
    flex-direction: column;
    justify-content: center;
	align-items: center;
	@media screen and ${mediaFeatures["for-mobile"]} {
		margin-top: 6vw;
		margin-bottom: 4vw;
		align-items: flex-start;
	}
	@media screen and ${mediaFeatures["for-tablet-only"]} {
		margin-bottom: 3vw;
		margin-top: 3vw;
		align-items: flex-start;
	}
	@media screen and ${mediaFeatures["for-hd"]} {
		margin-bottom: 40px;
		margin-top: 40px;
	}
`;
const getListViewedPayload = (group, category, timeFilter, sortValue) => {
    let payload = {
        type: "group",
        name: group.get("name", "").toLowerCase(),
        sort: sortValue
    };
    if (category || timeFilter) {
        payload["fromFilters"] = true;
    }
    return payload;
};
const GroupMonumentsView = props => {
    const { allowFavouriting, description, displayTitle, group, groupName, category, selectedCity, timeFilter, title, monumentCities } = props;
    const [currentCityFilter, setCurrentCityFilterInState] = useState("All Cities");
    const setCurrentCityFilter = event => setCurrentCityFilterInState(event.target.value);
    return (<Fragment>
			<div css={css(FilterHeadWrapper)}>
				<div css={css(FilterHead)}>
					<PageBanner>
						<span css={css(KeywordGoOut)}>{displayTitle} </span>(
						{<MonumentsAnimatedNumberWithSubscription chosenCity={currentCityFilter} category={category} group={group}/>}
						)
					</PageBanner>
				</div>
			</div>
			<MonumentsCityDropdown monumentCities={monumentCities} currentCityFilter={currentCityFilter} setCurrentCityFilter={setCurrentCityFilter}/>

			<CardListWrapper className="time-wrapper">
				<GroupMonumentsCityFilterCardList allowFavouriting={allowFavouriting} category={category} group={group} ssrImageCount={3} timeFilter={timeFilter} chosenCity={currentCityFilter}/>
			</CardListWrapper>
		</Fragment>);
};
const groupRedirectPathFn = city => generateSEOGroupCategoryLink(city, undefined, "events");
class GroupView extends React.PureComponent {
    fetchGooutDataIfRequired() {
        const { elpDataRequested, elpDataReceived, getELPData, selectedCity, isCityChanged } = this.props;
        this.pageUpdateUrl(isCityChanged, selectedCity);
        if (elpDataRequested || elpDataReceived) {
            return;
        }
        getELPData(selectedCity);
    }
    fetchMonumentsDataIfRequired() {
        const { monumentsDataRequested, monumentsDataReceived, fetchMonuments, elpDataReceived, groupName } = this.props;
        if (monumentsDataRequested || (monumentsDataReceived && !elpDataReceived)) {
            return;
        }
        if (groupName !== "Monuments") {
            return;
        }
        fetchMonuments();
    }
    //updating same page URL for redirection purpose on city change
    //for ex, URL type : all-travel-in-delhi/music, /all-events-in-bengaluru
    pageUpdateUrl(isCityChanged, selectedCity) {
        if (isCityChanged && selectedCity) {
            const newCity = cookies.get("newCity");
            window.location.href = generateSamePageURL(selectedCity, newCity);
        }
    }
    componentDidMount() {
        this.fetchGooutDataIfRequired();
        this.fetchMonumentsDataIfRequired();
        // if the favourites haven't been fetched yet, then fetch them
        const { favouritesFetched, fetchActiveFavourites, group, isLoggedIn, category, sortValue, timeFilter } = this.props;
        // if (!favouritesFetched && isLoggedIn) {
        // 	fetchActiveFavourites();
        // }
        // don't send event if the url has changed because of chosen sorters
        sendClevertapEvent(CLEVERTAP_ACTIONS.LIST_PAGE_VIEWED, getListViewedPayload(group, category, timeFilter, sortValue));
    }
    componentDidUpdate(prevProps) {
        this.fetchGooutDataIfRequired();
        this.fetchMonumentsDataIfRequired();
        const { favouritesFetched, fetchActiveFavourites, group, isFetchingFavourites, isLoggedIn, category, sortValue, timeFilter } = this.props;
        // if the login state just changed
        // if (isLoggedIn && !favouritesFetched && !isFetchingFavourites) {
        // 	fetchActiveFavourites();
        // }
        // don't send event if the url has changed because of chosen sorters
        if (prevProps.group.get("name") !== group.get("name")) {
            sendClevertapEvent(CLEVERTAP_ACTIONS.LIST_PAGE_VIEWED, getListViewedPayload(group, category, timeFilter, sortValue));
        }
    }
    renderGroupPanel() {
        const { allowFavouriting, description, displayTitle, group, groupName, cardCount, eventTypeCardCount, category, selectedCity, timeFilter, title, sortValue, showFilter, priceFilter, typeValue } = this.props;
        const isMonuments = groupName === "Monuments";
        const SortFiltersStyles = css `
			max-width: 1450px;
			display: flex;
			justify-content: center;
			${theme.mediaQueries["for-mobile"]} {
				flex-direction: column;
				margin: 0 0 12px 0;
				width: 88vw;
			}
			${theme.mediaQueries["for-tablet-only"]} {
				justify-content: left;
			}
			@media screen and ${mediaFeatures["for-large-tablet"]} {
				width: 100%;
			}
		`;
        const maxPrice = this.props.location.query["maxPrice"];
        return (<div key={`go-out-tab-panel-${groupName}`} className="discovery-tab-content">
				{selectedCity === "online" && (<CitySelectorContext.Provider value={{
                    redirectPathFn: groupRedirectPathFn,
                    source_page: "group_page"
                }}>
						{/* <HomePageCitySelector /> */}
					</CitySelectorContext.Provider>)}
				<BannerCarousel group={group}/>
				<SectionHelmet title={title} description={description} displayMode={"go-out"} tabName={`${groupName}`}/>
				{isMonuments ? (<GroupMonumentsView {...this.props}/>) : (<Fragment>
						<div css={css(FilterHeadWrapper)}>
							<div css={css(FilterHead)}>
								<ELPPageBanner typeValue={typeValue} displayTitle={displayTitle} selectedCity={selectedCity} timeFilter={timeFilter} cardCount={cardCount}/>
								<TimeBasedLinks hrefGenerator={timeFilter => generateSEOGroupCategoryLink(selectedCity, category, groupName, timeFilter, sortValue, priceFilter, typeValue, maxPrice)} showFilter={showFilter}/>
								<GroupGenreIconStripWithSubscription category={category} group={group} timeFilter={timeFilter} priceFilter={priceFilter} typeFilter={typeValue} maxPrice={maxPrice}/>
								<div css={SortFiltersStyles}>
									<SortSelectField source={groupName}/>
								</div>
							</div>
						</div>
						<CardListWrapper className="time-wrapper">
							<GroupFilterCardList allowFavouriting={allowFavouriting} category={category} group={group} ssrImageCount={3} timeFilter={timeFilter} priceFilter={priceFilter} typeFilter={typeValue}/>
						</CardListWrapper>
					</Fragment>)}
			</div>);
    }
    render() {
        const { elpDataReceived, monumentsDataReceived, monumentsDataRequested } = this.props;
        if (!elpDataReceived) {
            return <Loader />;
        }
        if (monumentsDataRequested && !monumentsDataReceived) {
            return <Loader />;
        }
        return <div className={"go-out-container"}>{this.renderGroupPanel()}</div>;
    }
}
GroupView.propTypes = {
    cardCount: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    selectedCity: PropTypes.string.isRequired,
    time: PropTypes.string,
    title: PropTypes.string.isRequired,
    showFilter: PropTypes.object
};
const mapStateToProps = state => {
    return {
        isCityChanged: getIsCityChanged(state)
    };
};
export default connect(mapStateToProps)(GroupView);
